module.exports = __webpack_public_path__ + "img/download-file.2b6b9cf9.svg";